import bem from 'utils/bem';

export const block = bem('edit-video-modal');
